<template>
  <div class="m-6">
    <p class="has-text-weight-bold is-size-4">{{ $t("af:profile.title") }}</p>

    <div class="af-card--user">
      <p class="has-text-weight-bold">
        {{ $t("af:profile.personal_data.title") }}
      </p>

      <p class="has-text-grey-icon">
        {{ $t("af:profile.personal_data.subtitle") }}
      </p>

      <div class="columns setting-tile mx-0 my-2">
        <div class="column is-one-quarter">
          {{ $t("af:profile.name.label") }}
        </div>
        <div class="column">
          <span class="has-text-weight-medium">{{
            customer.lastName
              ? customer.lastName + " " + customer.firstName
              : "-"
          }}</span>
        </div>
        <div class="column is-one-quarter">
          <UserEditNameModal
            :last-name="customer.lastName"
            :first-name="customer.firstName"
            @save="fetchCustomer"
          />
        </div>
      </div>

      <div class="columns setting-tile mx-0 my-2">
        <div class="column is-one-quarter">
          {{ $t("af:profile.email.label") }}
        </div>
        <div class="column">
          <span class="has-text-weight-medium" v-if="customer.email"
            >{{ customer.email }}
            <!-- <span v-if="customer.emailConfirmed">
              <b-icon
                icon-pack="fa"
                icon="check-circle"
                class="ml-4 is-blue-icon"
              ></b-icon>
              <label class="confirmation-font ml-1">
                {{ $t("af:profile.email.confirmed") }}</label
              >
            </span>
            <span v-else>
              <b-icon
                icon-pack="fa"
                icon="exclamation-circle"
                class="ml-4 is-yellow-icon"
              ></b-icon>
              <label class="confirmation-font ml-1">{{
                $t("af:profile.email.not_confirmed")
              }}</label>
            </span> -->
          </span>
          <span v-else>
            {{ $t("af:profile.email.email_placeholder") }}
            <b-icon
              icon-pack="fa"
              icon="exclamation-triangle"
              class="ml-4 is-red-icon"
            ></b-icon>
            <label class="confirmation-font ml-1">{{
              $t("af:profile.email.email_not_exists")
            }}</label>
          </span>
        </div>
        <!-- <div class="column is-one-quarter">
          <UserEditEmailModal
            :current-email="customer.email"
            :is-email-confirmed="customer.emailConfirmed"
            @save="fetchCustomer"
          />
        </div> -->
      </div>

      <!-- <div class="columns setting-tile mx-0 my-2">
        <div class="column is-one-quarter">
          {{ $t("af:profile.password.label") }}
        </div>
        <div class="column">
          <i>{{ $t("af:profile.password.cannot_be_shown") }}</i>
        </div>
        <div class="column is-one-quarter">
          <UserEditPasswordModal />
        </div>
      </div> -->

      <div class="columns setting-tile mx-0 my-2">
        <div class="column is-one-quarter">
          {{ $t("af:profile.phone.label") }}
        </div>
        <div class="column">
          <span class="has-text-weight-medium"
            >{{ customer.phone | VMask("+## ## ### ####") }}
            <!-- <b-icon
              icon-pack="fa"
              icon="check-circle"
              class="ml-4 is-blue-icon"
            ></b-icon>
            <label class="confirmation-font ml-1">
              {{ $t("af:profile.phone.confirmed") }}</label
            > -->
          </span>
        </div>
        <!-- <div class="column is-one-quarter">
          <UserEditPhoneModal :phone="customer.phone" @save="fetchCustomer" />
        </div> -->
      </div>

      <p class="has-text-weight-bold mt-6">
        {{ $t("af:profile.delete.title") }}
      </p>

      <p class="has-text-grey-icon">
        {{ $t("af:profile.delete.subtitle") }}
      </p>

      <p class="has-text-weight-medium">
        {{ $t("af:profile.delete.button.delete.label") }}
        <a @click="onDelete">{{
          $t("af:profile.delete.button.delete.text")
        }}</a>
      </p>
      <p class="has-text-weight-medium">
        {{ $t("af:profile.delete.button.gdpr.label") }}
        <a @click="onGdpr">{{ $t("af:profile.delete.button.gdpr.text") }}</a>
      </p>

      <div class="mt-6">
        <b-button icon-left="power-off" type="is-danger" @click="logout">{{
          $t("af:profile.button.logout")
        }}</b-button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import i18n from "@/plugins/i18n";

export default {
  name: "LeasingProfile",
  components: {
    // UserStatements: () => import("@/components/user/UserStatements.vue"),
    // UserDocuments: () => import("@/components/user/UserDocuments.vue"),
    UserEditNameModal: () => import("@/components/user/UserEditNameModal.vue"),
    // UserEditPasswordModal: () =>
    //   import("@/components/user/UserEditPasswordModal.vue"),
    // UserEditPhoneModal: () =>
    //   import("@/components/user/UserEditPhoneModal.vue"),
    // UserEditEmailModal: () =>
    //   import("@/components/user/UserEditEmailModal.vue"),
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      customer: "profile/get",
    }),
  },
  methods: {
    ...mapActions({
      fetchCustomer: "profile/fetch",
      saveCustomer: "profile/save",
      sessionLogout: "session/logout",
      dropLeasingPrescore: "leasingPrescore/drop",
    }),
    onDelete() {
      this.$buefy.dialog.confirm({
        title: i18n.t("af:profile.confirmation.delete.title"),
        message: i18n.t("af:profile.confirmation.delete.subtitle"),
        cancelText: i18n.t("af:profile.confirmation.delete.button.cancel"),
        confirmText: i18n.t("af:profile.confirmation.delete.button.confirm"),
        type: "is-success",
        onConfirm: () => {
          this.customer.gdprDeletion = true;
          this.save();
        },
      });
    },
    onGdpr() {
      this.$buefy.dialog.confirm({
        title: i18n.t("af:profile.confirmation.gdpr.title"),
        message: i18n.t("af:profile.confirmation.gdpr.subtitle"),
        cancelText: i18n.t("af:profile.confirmation.gdpr.button.cancel"),
        confirmText: i18n.t("af:profile.confirmation.gdpr.button.confirm"),
        type: "is-success",
        onConfirm: () => {
          this.customer.gdprDataRequest = true;
          this.save();
        },
      });
    },
    async save() {
      try {
        await this.saveCustomer(this.customer);
        this.$buefy.toast.open({
          message: i18n.t("af:profile.message.successful_save"),
          type: "is-success",
        });
      } catch (e) {
        this.$buefy.toast.open({
          message: i18n.t("af:profile.message.failed_save"),
          type: "is-danger",
        });
      }
    },
    logout() {
      this.sessionLogout();
      this.dropLeasingPrescore();
      this.$router.push({
        name: "LeasingLogin",
      });
    },
  },
  async created() {
    await this.fetchCustomer();
  },
};
</script>
